import { all, put, take } from 'redux-saga/effects';

import { PIPELINE__LOAD_THIRD_PARTY_SCRIPTS } from 'PipeRouter';
import loadScripts from './loadScripts';


function* pipeline() {
  while (true) {
    const { data:{ cmd, data }} = yield take(PIPELINE__LOAD_THIRD_PARTY_SCRIPTS);

    yield put({ type: cmd, data });
  }
}

export default function*() {
  yield all([
    pipeline(),
    loadScripts()
  ]);
}
